var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { getTypographyStyles, TYPOGRAPHY_TYPE } from '../../../theme/typography';
import { GROUP_TYPE, useGroup } from '../Group';
import { useEnvironment } from '../../providers/env';
export var LABEL_SIZE;
(function (LABEL_SIZE) {
    LABEL_SIZE["SM"] = "sm";
    LABEL_SIZE["MD"] = "md";
    LABEL_SIZE["LG"] = "lg";
})(LABEL_SIZE || (LABEL_SIZE = {}));
export const SIZE_TYPOGRAPHY_MAP = {
    [LABEL_SIZE.SM]: TYPOGRAPHY_TYPE.CONTROL_SMALL,
    [LABEL_SIZE.MD]: TYPOGRAPHY_TYPE.CONTROL_MEDIUM,
    [LABEL_SIZE.LG]: TYPOGRAPHY_TYPE.CONTROL_LARGE,
};
export const Label = (_a) => {
    var { sx, size, standalone, typography: typographyParam } = _a, rest = __rest(_a, ["sx", "size", "standalone", "typography"]);
    const { labelId, labelTargetId, type: groupType } = useGroup();
    const { flagInDevelopment } = useEnvironment();
    const typography = typographyParam || SIZE_TYPOGRAPHY_MAP[size || LABEL_SIZE.MD];
    if (groupType !== GROUP_TYPE.GROUP &&
        groupType !== GROUP_TYPE.RAW &&
        !standalone) {
        flagInDevelopment('Label component should be used within a Group component with property type={GROUP_TYPE.GROUP} or given the standalone flag');
    }
    return (_jsx("label", Object.assign({ id: labelId, htmlFor: labelTargetId, sx: Object.assign(Object.assign({}, getTypographyStyles(typography)), sx) }, rest)));
};
